module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/28.ec55ab46.png";